import { useState } from "react";
import { useDispatch } from "react-redux";
import { setToast } from "../../../redux/slice/system";
import { useParams, useNavigate } from "react-router-dom";
import { useAbortedEffect, useTab } from "../../../components/hooks";
import { MemberAPI } from "../../../axios/api";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import MemberRecordHeartbeat from "../../member/record/heartbeat";
import MemberRecordWeight from "../../member/record/weight";
import MemberRecordSugar from "../../member/record/sugar";
import MemberRecordUncomfortable from "../../member/record/uncomfortable";
import MemberRecordHealth from "../../member/record/health";
import MemberRecordExecutionRate from "./executionRate";
import { option_category, option_category_obj } from "../../../service/option";

export default function BackRecordList() {
  const route_params = useParams();
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbItem = [
    {
      key: 1,
      label: "記錄管理",
    },
  ];
  const { setTabData, activeIndex, renderTab } = useTab({
    moduleType: "underline",
    className: "mb-3",
    data: [
      ...option_category.record.map((item, index) => ({ ...item, key: index })),
      {
        label: "執行率",
        value: "execution_rate",
      },
    ],
    matchTab: ["/back/record"],
  });
  const [memberData, setMemberData] = useState([]);

  useAbortedEffect((signal) => {
    let params = {
      page: -1,
    };

    MemberAPI.getUserList({ data: params, options: { signal } }).then(
      (result) => {
        let { Response, data, total, message } = result;

        if (Response === 1) {
          setMemberData(data);
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }
      }
    );
  }, []);

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <div className="border-round-lg bg-white mt-3 p-3">
        <div className="px-3">{renderTab}</div>

        {activeIndex === 0 && (
          <MemberRecordHeartbeat moduleType="back" memberData={memberData} />
        )}
        {activeIndex === 1 && (
          <MemberRecordSugar moduleType="back" memberData={memberData} />
        )}
        {activeIndex === 2 && (
          <MemberRecordWeight moduleType="back" memberData={memberData} />
        )}
        {activeIndex === 3 && (
          <MemberRecordUncomfortable
            moduleType="back"
            memberData={memberData}
          />
        )}
        {activeIndex === 4 && (
          <MemberRecordHealth moduleType="back" memberData={memberData} />
        )}
        {activeIndex === 5 && (
          <MemberRecordExecutionRate memberData={memberData} />
        )}
      </div>
    </>
  );
}
